var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownLeftAndUpRightToCenterSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M215.1,272h-136c-12.9,0-24.6,7.8-29.6,19.8c-4.1,12-1.3,25.8,7.8,34.9l30.1,30.1L9.4,434.7 c-12.5,12.5-12.5,32.8,0,45.2L32,502.6c12.5,12.5,32.8,12.5,45.3,0l78.1-78.1l30.1,30.1c6.1,6.1,14.3,9.4,22.6,9.4 c4.1,0,8.3-0.8,12.2-2.4c12-5,19.8-16.6,19.8-29.6V296C239.1,282.7,229.3,272,215.1,272z M296,240h136c12.9,0,24.6-7.8,29.6-19.8 c5-12,2.2-25.7-6.9-34.9l-30.1-30.1l78.1-78.1c12.5-12.5,12.5-32.8,0-45.3L480,9.4c-12.5-12.5-32.8-12.5-45.3,0l-78.1,78.1 l-30.1-30.1c-9.2-9.1-22.9-11.8-34.9-6.9c-12,5-19.8,16.6-19.8,29.6v135.1C272,229.3,282.7,240,296,240z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownLeftAndUpRightToCenterSolid);
export default __webpack_public_path__ + "static/media/down-left-and-up-right-to-center-solid.824558c8f12fdd19e05d330ae5fdcdea.svg";
export { ForwardRef as ReactComponent };